import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import no from './locales/no.json'

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    no: { translation: no },
  },
  lng: localStorage.getItem('i18nLanguage') || 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
})

export default i18n
